import {deserialize} from 'libs/cerialize';

export class SupersetSettings{

    @deserialize
    RootUrl: string;

    @deserialize
    TenantUserName: string;

    @deserialize
    AssistantModel: string;

    @deserialize
    AssistantEnabled: boolean;
}
